import { List } from '@zillow/constellation-10';

const InfoList = ({ infos }: { infos: Array<string> }) => (
  <List.Root appearance="bullet" css={{ margin: 'auto', maxWidth: '460px' }}>
    {infos.map((infoText) => (
      <List.Item key={infoText} css={{ paddingBottom: '600', paddingBlock: '0' }}>
        {infoText}
      </List.Item>
    ))}
  </List.Root>
);

export default InfoList;
